import { FieldDataNode } from "rc-tree";
import { ExplorerDataNode } from "../treeDataManipulation";

const getNestedPaths = (node: FieldDataNode<ExplorerDataNode>): string[] => {
  if (node.children && node.children.length)
    return [node.key, ...node.children.flatMap((item: FieldDataNode<ExplorerDataNode>) => {
      if (item.isLeaf)
        return item.key;
      else
        return getNestedPaths(item);
    })];
  else
    return [node.key];
}

export const rename = (currentName: string, newName: string, targetNode: FieldDataNode<ExplorerDataNode>) => {
  newName = newName.trim();

  if (targetNode.isLeaf)
    return [[targetNode.key, targetNode.key.replace(currentName, newName)]];

  const paths = getNestedPaths(targetNode);
  const result = paths.map((item) => [item, item.replace(currentName, newName)]);
  return result;
};